import styled, { css } from 'styled-components';
import { Link } from 'react-scroll';

export const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 10;
  transition: 0.2s all ease-in-out;
  display: flex;
  justify-content: center;
  background: ${(p) => p.theme.background};
  height: 70px;

  ${(p) =>
    p.isScrollDown &&
    css`
      background: ${(p) => p.theme.components};
      height: 55px;
      box-shadow: 0px 3px 3px -2px ${(p) => p.theme.accent.primary}45;
    `}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1300px;
  padding: 0 16px;
`;

export const Logo = styled.a`
  color: ${(p) => p.theme.accent.primary};
  text-decoration: none;
  list-style: none;
  outline: none;
  font-size: 1.6rem;
  font-weight: 800;
  transition: 0.2s ease-in-out;
  letter-spacing: 0.3rem;

  @media screen and (max-width: 767px) {
    font-size: 1.4rem;
  }

  span:nth-of-type(even) {
    color: ${(p) => p.theme.text};
  }

  &:hover {
    filter: brightness(170%);
    letter-spacing: 0.5rem;
  }
`;

export const Menu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  height: 100%;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const NavLink = styled(Link)`
  padding: 0.4rem 0.6rem;
  font-weight: bold;
  color: ${(p) => p.theme.accent.secondary};
  text-decoration: none;
  cursor: pointer;
  margin-right: 1rem;
  border-radius: 5px;
  transition: 0.2s background ease-in-out;

  &:hover {
    background: ${(p) => p.theme.accent.primary}20;
  }

  &:active {
    background: ${(p) => p.theme.accent.primary}50;
  }
`;
